import { __decorate } from "tslib";
import { AutoEncoder, field, IntegerDecoder } from '@common/encoding';
import { upgradePriceFrom2To4DecimalPlaces } from './upgradePriceFrom2To4DecimalPlaces.js';
export class ReduceablePrice extends AutoEncoder {
    price = 0;
    reducedPrice = null;
    getPrice(isReduced) {
        if (this.reducedPrice === null) {
            return this.price;
        }
        return isReduced ? this.reducedPrice : this.price;
    }
    forMember(member) {
        return this.getPrice(member.patchedMember.details.shouldApplyReducedPrice);
    }
}
__decorate([
    field({ decoder: IntegerDecoder }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], ReduceablePrice.prototype, "price", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true }),
    field({ ...upgradePriceFrom2To4DecimalPlaces, nullable: true })
], ReduceablePrice.prototype, "reducedPrice", void 0);
//# sourceMappingURL=ReduceablePrice.js.map